<script>
    import TextField from "../common/text-field.vue";

    const DEBOUNCE_TIME = 500;

    export default {
        name: "search-field",
        components: {TextField},
        props: {
            name: String,
            autocomplete: String,
            role: String
        },
        data() {
            const storedSearchTerm = this.getSearchTermFromLocalStorage()

            return {
                searchTerm: storedSearchTerm
            };
        },
        methods: {
            getSearchTermFromLocalStorage() {
                const storageKey = `${this.name}-table-search.${Laravel.activeUser}.${Laravel.activeProject}`;
                const storageObjStr = localStorage.getItem(storageKey);
                const storedSearchObj = storageObjStr ? JSON.parse(storageObjStr) : null;
                return storedSearchObj?.sSearch;
            },
            handleChange(searchTerm) {
                this.searchTerm = searchTerm;
                this.debouncedEmit(this.name, this.searchTerm);
            },
            debouncedEmit: _.debounce((name, searchTerm) => {
                EaseEventBus.fire('searchTable' + _.capitalize(name), searchTerm);
            }, DEBOUNCE_TIME)
        },
        computed: {
            tSearch() {
                return Lang.langGet('Search');
            }
        }
    }
</script>

<template>
    <div class="search-field-container">
        <text-field
            :autocomplete="autocomplete"
            :role ="role"
            :value="searchTerm"
            :label="tSearch"
            @input="handleChange"
        />
    </div>
</template>

<style>
    .search-field-container {
        background-color: white;
    }

    .search-field-container .v-text-field__details {
        display: none !important;
    }

    .search-field-container .v-input__slot {
        margin: 0 !important;
    }
</style>
